export const categories = [
  { id: 1, slug: 'romance', name: '恋爱 romance', description: '甜蜜浪漫的韩国恋爱漫画', icon: 'ri-heart-line' },
  { id: 2, slug: 'action', name: '热血 action', description: '激情澎湃的动作热血韩漫', icon: 'ri-fire-line' },
  { id: 3, slug: 'fantasy', name: '奇幻 fantasy', description: '魔幻世界的奇幻冒险故事', icon: 'ri-magic-line' },
  { id: 4, slug: 'comedy', name: '搞笑 comedy', description: '轻松幽默的韩国搞笑漫画', icon: 'ri-emotion-laugh-line' },
  { id: 5, slug: 'thriller', name: '悬疑 thriller', description: '烧脑紧张的悬疑推理韩漫', icon: 'ri-search-eye-line' },
  { id: 6, slug: 'drama', name: '剧情 drama', description: '深刻感人的剧情向韩国漫画', icon: 'ri-movie-2-line' },
  { id: 7, slug: 'school', name: '校园 school', description: '青春洋溢的校园韩漫故事', icon: 'ri-building-2-line' },
  { id: 8, slug: 'historical', name: '古风 historical', description: '古色古香的韩国历史漫画', icon: 'ri-ancient-gate-line' },
];

export const comics = [
  {
    id: 1,
    title: '某天成为公主',
    author: 'Spoon',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20princess%20with%20long%20blonde%20hair%20wearing%20an%20elegant%20pink%20royal%20dress%20in%20a%20palace%20setting%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20detailed%20anime%20art%20style%2C%20clean%20illustration&width=600&height=800&seq=comic-01&orientation=portrait',
    rating: 9.5,
    description: '一觉醒来，我竟然变成了小说中的公主殿下？而且还是那个注定要被亲生父亲处死的悲惨公主！为了活下去，我决定要成为父王最宠爱的女儿。可是，这个冷酷无情的皇帝陛下，为什么看我的眼神越来越温柔了呢？这是一部关于亲情、成长与爱的温馨宫廷浪漫故事。',
    category: 'romance',
    tags: ['宫廷', '穿越', '父女', '治愈'],
    chapters: 125,
    views: 3850000,
    status: '连载中',
    updateDate: '2026-08-04',
    featured: true,
  },
  {
    id: 2,
    title: '我独自升级',
    author: 'Chugong / DUBU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20male%20hunter%20with%20dark%20hair%20and%20glowing%20blue%20eyes%20wearing%20black%20combat%20armor%20in%20a%20dungeon%20setting%2C%20dark%20atmosphere%2C%20action%20vibes%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-02&orientation=portrait',
    rating: 9.8,
    description: '十年前，世界各地出现了连接异次元的"门"，同时也觉醒了一部分拥有特殊能力的人类——"猎人"。故事的主角成振宇，是被称为"人类最弱兵器"的E级猎人。某天，他在一次地下城探索中遭遇了生死危机，却意外获得了神秘系统的力量，成为了唯一能够"升级"的猎人。从最弱到最强，一段热血沸腾的逆袭之路就此展开。',
    category: 'action',
    tags: ['战斗', '系统', '升级', '猎人'],
    chapters: 179,
    views: 8920000,
    status: '已完结',
    updateDate: '2026-07-20',
    featured: true,
  },
  {
    id: 3,
    title: '恶女的定义',
    author: 'Soohee / Gaya',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20an%20elegant%20villainess%20woman%20with%20red%20hair%20and%20sharp%20eyes%20wearing%20a%20luxurious%20dark%20gown%20holding%20a%20fan%2C%20dramatic%20lighting%2C%20rich%20colors%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-03&orientation=portrait',
    rating: 9.3,
    description: '我是这个帝国最恶毒的女人——公爵府的大小姐凯琳娜。所有人都恨我、怕我，但这正是我想要的。因为我清楚地知道，在这个世界里，善良只会让你沦为棋子。可是为什么，那个本该对我恨之入骨的皇太子，却偏偏对这样的我产生了兴趣？一场权力与情感交织的宫廷博弈拉开帷幕。',
    category: 'fantasy',
    tags: ['恶女', '宫廷', '重生', '权谋'],
    chapters: 98,
    views: 2450000,
    status: '连载中',
    updateDate: '2026-08-03',
    featured: true,
  },
  {
    id: 4,
    title: '女神降临',
    author: 'Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20gorgeous%20young%20woman%20with%20long%20brown%20hair%20and%20perfect%20makeup%20in%20a%20school%20uniform%2C%20bright%20and%20cheerful%20atmosphere%2C%20beauty%20transformation%20theme%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-04&orientation=portrait',
    rating: 9.1,
    description: '林珠京是一个因为外貌而备受欺凌的普通女孩。在经历了无数次的嘲笑和冷眼之后，她决定通过化妆来改变自己的人生。转学到新学校后，凭借着精湛的化妆技术，她摇身一变成为了全校瞩目的"女神"。然而，她的素颜秘密却意外被学校里最受欢迎的男生发现了。一个关于美丽、自信与真爱的青春故事。',
    category: 'school',
    tags: ['化妆', '校园', '恋爱', '成长'],
    chapters: 224,
    views: 5680000,
    status: '已完结',
    updateDate: '2026-06-15',
    featured: true,
  },
  {
    id: 5,
    title: '看脸时代',
    author: '朴泰俊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20two%20contrasting%20male%20characters%20one%20handsome%20and%20one%20overweight%20in%20split%20composition%2C%20urban%20school%20setting%2C%20dramatic%20contrast%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-05&orientation=portrait',
    rating: 9.4,
    description: '朴亨锡是一个因为肥胖外貌而长期遭受校园霸凌的高中生。在某天，他意外发现自己拥有了两个身体——一个是他原本肥胖的身体，另一个则是完美帅气的身体。当一个身体沉睡时，另一个身体就会醒来。他决定利用这个能力，在充满暴力和欺凌的校园中为自己讨回公道。两个身体、两个人生，一个关于正义与成长的残酷青春物语。',
    category: 'drama',
    tags: ['校园', '双身', '霸凌', '成长'],
    chapters: 312,
    views: 7450000,
    status: '连载中',
    updateDate: '2026-08-05',
    featured: true,
  },
  {
    id: 6,
    title: '全知读者视角',
    author: 'Sing N Song / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20male%20protagonist%20with%20glasses%20holding%20a%20glowing%20book%20surrounded%20by%20apocalyptic%20scenery%2C%20dark%20atmosphere%20with%20monsters%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-06&orientation=portrait',
    rating: 9.7,
    description: '金独子是一个普通的上班族，他唯一的爱好就是阅读一本名为《在灭亡的世界中生存的三种方法》的网络小说。这部小说连载了十年，而他是这世界上唯一的读者。然而就在小说完结的那一天，小说中的世界竟然变成了现实。凭借十年来积累的剧情知识，金独子成为了这个世界中唯一知道"未来"的人。一段孤身改变命运的史诗冒险就此展开。',
    category: 'fantasy',
    tags: ['末世', '系统', '生存', '冒险'],
    chapters: 210,
    views: 6230000,
    status: '连载中',
    updateDate: '2026-08-04',
    featured: false,
  },
  {
    id: 7,
    title: '她的私生活',
    author: '金成妍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20professional%20woman%20with%20short%20dark%20hair%20in%20office%20attire%20holding%20a%20phone%20with%20idol%20merchandise%20nearby%2C%20romantic%20comedy%20vibe%2C%20bright%20colors%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-07&orientation=portrait',
    rating: 8.9,
    description: '成德美表面上是美术馆的首席策展人，干练、专业、无可挑剔。但她的私生活却有着不为人知的另一面——她是一个狂热的偶像粉丝站站长！白天在美术馆优雅地策划展览，晚上则化身粉丝站站长追踪偶像的动态。当她的两个身份即将被新上任的馆长撞破时，一段啼笑皆非的爱情故事就此展开。',
    category: 'romance',
    tags: ['职场', '追星', '恋爱', '秘密'],
    chapters: 87,
    views: 1890000,
    status: '已完结',
    updateDate: '2026-05-30',
    featured: false,
  },
  {
    id: 8,
    title: '北剑神皇',
    author: '海洋 / 洪氏',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20martial%20artist%20with%20long%20white%20hair%20holding%20a%20glowing%20sword%20in%20ancient%20Korean%20setting%2C%20snow%20mountain%20background%2C%20epic%20atmosphere%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-08&orientation=portrait',
    rating: 9.6,
    description: '北天剑皇——这个名号曾经让整个武林闻风丧胆。然而在一次背叛中，剑皇陨落了。百年之后，他以一个少年之身重生，却发现昔日的北天剑派已经没落，武林格局早已天翻地覆。带着前世的记忆与绝世剑法，他踏上了重振剑派、复仇雪恨的道路。剑指苍穹，皇者归来！',
    category: 'action',
    tags: ['武侠', '重生', '剑法', '复仇'],
    chapters: 156,
    views: 4210000,
    status: '连载中',
    updateDate: '2026-08-02',
    featured: false,
  },
  {
    id: 9,
    title: '搞笑一家人',
    author: '李末年',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20chaotic%20funny%20family%20scene%20with%20exaggerated%20expressions%2C%20comedy%20style%2C%20warm%20home%20setting%2C%20colorful%20and%20lively%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-09&orientation=portrait',
    rating: 9.0,
    description: '这是一个关于韩国普通家庭的爆笑日常。严厉的爸爸、唠叨的妈妈、捣蛋的弟弟、傲娇的姐姐，还有我们那个总能把一切搞砸的主角。从餐桌上的战争到客厅里的角逐，从学校里的糗事到邻里间的趣闻，每一天都充满了意想不到的笑料。笑中带泪，这就是我们的家庭喜剧！',
    category: 'comedy',
    tags: ['家庭', '日常', '搞笑', '温馨'],
    chapters: 198,
    views: 3120000,
    status: '连载中',
    updateDate: '2026-08-04',
    featured: false,
  },
  {
    id: 10,
    title: '杀人者的购物中心',
    author: '姜草',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20dark%20shopping%20mall%20with%20shadowy%20figures%20and%20weapons%20displayed%2C%20thriller%20noir%20atmosphere%2C%20suspenseful%20mood%2C%20dark%20tones%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-10&orientation=portrait',
    rating: 9.2,
    description: '郑智安在叔叔去世后，继承了叔叔留给他的遗产——一家看似普通的购物中心。然而当他踏入这家购物中心的那一刻，他的人生彻底改变了。这里根本不是普通的购物中心，而是一个为杀人犯提供各种"工具"的地下暗杀者交易场所。更糟糕的是，追杀叔叔的人现在把目标转向了他。生存与道德的抉择，就此开始。',
    category: 'thriller',
    tags: ['悬疑', '暗杀', '生存', '复仇'],
    chapters: 67,
    views: 2780000,
    status: '已完结',
    updateDate: '2026-04-20',
    featured: false,
  },
  {
    id: 11,
    title: '重生之都市修仙',
    author: '方圆',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20cultivator%20man%20in%20modern%20city%20clothing%20with%20spiritual%20energy%20effects%20surrounding%20him%2C%20urban%20fantasy%20setting%2C%20mystical%20atmosphere%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-11&orientation=portrait',
    rating: 9.1,
    description: '一代仙尊陈凡，遭人暗算陨落天劫，却意外重生回到了地球的高中时代。前世他为了修仙抛弃了所有，这一世，他要弥补所有的遗憾。拥有千年修仙记忆的他，在这末法时代的地球上，依然能够踏上巅峰。校花、豪门、武道、修仙——这一世，他要活出不一样的精彩！',
    category: 'fantasy',
    tags: ['修仙', '都市', '重生', '强者'],
    chapters: 345,
    views: 5120000,
    status: '连载中',
    updateDate: '2026-08-05',
    featured: false,
  },
  {
    id: 12,
    title: '甜蜜的陷阱',
    author: '朴慧琳',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20couple%20in%20romantic%20embrace%20with%20sweet%20candy%20and%20dessert%20aesthetic%2C%20pink%20and%20pastel%20color%20palette%2C%20romantic%20vibe%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-12&orientation=portrait',
    rating: 8.8,
    description: '甜品师苏念开了一家小小的甜品店，她做的甜品能让顾客感受到幸福的味道。某天，一位冷酷的米其林三星主厨走进了她的店，对她做的甜品不屑一顾，却对她的味觉天赋产生了浓厚的兴趣。一个温暖治愈的甜品师与挑剔毒舌的顶级主厨之间，甜蜜又火药味十足的爱情故事。',
    category: 'romance',
    tags: ['美食', '甜品', '恋爱', '职场'],
    chapters: 56,
    views: 1230000,
    status: '连载中',
    updateDate: '2026-08-01',
    featured: false,
  },
  {
    id: 13,
    title: '李氏朝鲜秘史',
    author: '金载沅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20noble%20Korean%20historical%20figure%20in%20traditional%20hanbok%20in%20ancient%20palace%20setting%2C%20classical%20elegant%20atmosphere%2C%20historical%20drama%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-13&orientation=portrait',
    rating: 9.3,
    description: '朝鲜王朝中期，宫廷内外暗流涌动。一名出身卑微的书生凭借才智进入朝廷，却意外卷入了一场惊天的权力阴谋之中。在王权的更迭、党争的漩涡中，他必须步步为营，在忠诚与背叛、道义与利益之间做出选择。一段鲜为人知的李氏朝鲜秘史，通过细腻的画笔徐徐展开。',
    category: 'historical',
    tags: ['历史', '宫廷', '权谋', '朝鲜'],
    chapters: 88,
    views: 1670000,
    status: '连载中',
    updateDate: '2026-07-28',
    featured: false,
  },
  {
    id: 14,
    title: '幽灵医生',
    author: '李贤秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20ghostly%20doctor%20figure%20in%20white%20coat%20with%20translucent%20effect%20in%20a%20hospital%20setting%2C%20supernatural%20medical%20drama%2C%20mysterious%20atmosphere%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-14&orientation=portrait',
    rating: 9.0,
    description: '天才外科医生车英民在一场车祸后变成了灵魂状态。他能看到、听到一切，却无法与任何人交流。直到某天，他发现自己的灵魂能够附着在另一个医生——一个医术糟糕但心地善良的住院医师身上。从此，一个"幽灵"指导着一个"菜鸟"，在医院里上演了一幕幕惊心动魄又温暖人心的医疗奇迹。',
    category: 'drama',
    tags: ['医疗', '灵魂', '喜剧', '温情'],
    chapters: 73,
    views: 1980000,
    status: '已完结',
    updateDate: '2026-03-15',
    featured: false,
  },
  {
    id: 15,
    title: '放学后的特别课程',
    author: 'Narak',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20two%20high%20school%20students%20in%20classroom%20after%20school%20with%20sunset%20lighting%2C%20romantic%20coming%20of%20age%20vibe%2C%20warm%20colors%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-15&orientation=portrait',
    rating: 8.7,
    description: '全校第一的学霸与全校倒数第一的学渣，因为一次意外被安排成了课后辅导的搭档。她冷若冰霜，他热情似火；她追求完美，他随性而为。在一次次放学后的特别课程中，两个完全不同世界的人，渐渐发现了彼此身上令人心动的闪光点。青春的悸动，在黄昏的教室里悄然萌芽。',
    category: 'school',
    tags: ['校园', '学霸', '恋爱', '青春'],
    chapters: 64,
    views: 1450000,
    status: '连载中',
    updateDate: '2026-08-03',
    featured: false,
  },
  {
    id: 16,
    title: '魔咒',
    author: 'Honey B',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20character%20surrounded%20by%20magical%20cursed%20symbols%20and%20dark%20energy%2C%20supernatural%20horror%20vibe%2C%20dark%20purple%20and%20black%20tones%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-16&orientation=portrait',
    rating: 9.4,
    description: '在一个被诅咒笼罩的小镇上，任何踏入镇子的人都会受到魔咒的影响，逐渐失去自己最珍贵的东西。记者韩瑞镇为了调查姐姐失踪的真相，孤身进入了这个禁忌之地。随着调查的深入，他发现这个诅咒背后隐藏着一个延续了数百年的可怕秘密。而解开诅咒的钥匙，竟然就在他自己身上。',
    category: 'thriller',
    tags: ['恐怖', '诅咒', '调查', '超自然'],
    chapters: 92,
    views: 2350000,
    status: '连载中',
    updateDate: '2026-08-02',
    featured: false,
  },
];

export const faqData = [
  {
    question: '韩国漫画网上的漫画都是免费的吗？',
    answer: '是的，韩国漫画网上所有漫画均提供免费在线观看服务。我们致力于为广大韩漫爱好者提供优质、无删减的漫画阅读体验，无需付费即可畅享海量韩国漫画资源。',
  },
  {
    question: '网站上的漫画更新频率如何？',
    answer: '我们与多家韩国漫画平台保持紧密合作，漫画更新与韩国本土保持同步。热门连载漫画通常每周更新1-2话，确保您能够第一时间看到最新的韩漫内容。',
  },
  {
    question: '为什么选择下拉式阅读方式？',
    answer: '下拉式（Webtoon）是韩国漫画的主流阅读形式，相比传统的翻页式漫画，下拉式阅读更加流畅自然，特别适合在手机和电脑上阅读。所有漫画画面完整呈现，无需缩放，为您带来最舒适的阅读体验。',
  },
  {
    question: '漫画是否有删减或修改？',
    answer: '我们始终坚持提供原汁原味的韩国漫画内容，所有漫画均为无删减版本。我们尊重创作者的原始表达，保留完整的故事情节和画面，让读者能够完整体验漫画的魅力。',
  },
  {
    question: '如何搜索我想看的漫画？',
    answer: '您可以通过首页的搜索功能输入漫画名称或作者进行搜索，也可以通过分类页面按题材浏览感兴趣的漫画。我们还提供了热门推荐和排行榜，帮助您发现更多好看的韩国漫画。',
  },
];

export const testimonials = [
  {
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20anime%20style%20portrait%20of%20young%20female%20with%20soft%20smile%2C%20simple%20white%20background%2C%20gentle%20expression%2C%20pastel%20tones&width=120&height=120&seq=avatar-01&orientation=squarish',
    comment: '这个网站真的太棒了！画质清晰，更新速度也很快，终于不用到处找韩漫资源了。强烈推荐给所有韩漫爱好者！',
    rating: 5,
  },
  {
    name: '星辰大海',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20anime%20style%20portrait%20of%20young%20male%20with%20friendly%20expression%2C%20simple%20white%20background%2C%20warm%20vibe%2C%20clean%20style&width=120&height=120&seq=avatar-02&orientation=squarish',
    comment: '下拉式阅读体验很流畅，没有广告弹窗干扰。分类也很全，从恋爱到热血，什么类型的漫画都能找到。每天必刷的网站！',
    rating: 5,
  },
  {
    name: '樱花飘落',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20anime%20style%20portrait%20of%20cute%20female%20with%20pink%20hair%2C%20simple%20white%20background%2C%20cheerful%20expression%2C%20pastel%20aesthetic&width=120&height=120&seq=avatar-03&orientation=squarish',
    comment: '作为韩漫老粉，这个网站的资源真的非常丰富。很多冷门的好看漫画都能找到，感谢平台让我发现了这么多宝藏作品！',
    rating: 5,
  },
];

export const siteInfo = {
  name: '韩国漫画网',
  description: '韩国漫画网是国内专业的韩国漫画在线阅读平台，提供海量好看韩国漫画资源，支持韩漫在线无删减下拉式免费阅读。涵盖恋爱、热血、奇幻、搞笑、悬疑、剧情等多种分类，每日同步更新最新韩漫章节，为您带来原汁原味的完整漫画体验。',
  contact: {
    email: 'contact@koreanmanhwa.com',
    wechat: 'KManhwa_Official',
    qq: '987654321',
    weibo: '@韩国漫画网官方',
  },
  stats: {
    totalComics: '50,000+',
    dailyVisitors: '200万+',
    yearsRunning: '8',
    totalChapters: '300万+',
  },
};